import { ATexts } from './ATexts';

/**
 * The texts of every module, in one place: buttons, labels, messages and hints of the shared components, and what
 * several modules use. What only one module shows stays in its `<Module>Texts`.
 */
class CommonTextsClass extends ATexts {
    // - headlines
    public readonly ActionFailed = 'Aktion fehlgeschlagen';
    public readonly Attention = 'Achtung!';
    public readonly CreateFailed = 'Anlegen fehlgeschlagen';
    public readonly DeleteFailed = 'Löschen fehlgeschlagen';
    public readonly LoadFailed = 'Laden fehlgeschlagen';
    public readonly NoRights = 'Keine Berechtigung';
    public readonly SaveFailed = 'Speichern fehlgeschlagen';

    // - messages
    public readonly ApiUnreachable = 'Die Schnittstelle ist nicht erreichbar oder hat ungültig geantwortet.';
    public readonly EmailDuplicate = 'Diese Adresse steht schon in der Liste.';
    public readonly EmailPending = 'Bitte übernimm oder verwirf die neue E-Mail-Adresse.';
    public readonly EmailRequiredForUser = 'Zu dieser Person gehört ein Benutzer; er braucht mindestens eine E-Mail-Adresse zum Anmelden.';
    public readonly PageLoadFailed = 'Die Seite konnte nicht geladen werden. Vielleicht gibt es eine neue Version – bitte lade die Seite neu.';

    // - buttons, labels, hints
    public readonly Account = 'Konto';
    public readonly Acronym = 'Kürzel';
    public readonly Add = 'Hinzufügen';
    public readonly AdminOnly = 'Nur für Admins sichtbar';
    public readonly Apply = 'Übernehmen';
    public readonly Ascending = 'Aufsteigend';
    public readonly BackTo = 'Zurück zu den {list}';
    public readonly ButtonFallback = 'Button';
    public readonly Cancel = 'Abbrechen';
    public readonly Card = 'Visitenkarte';
    public readonly Choose = '{label} auswählen';
    public readonly ChooseContactFirst = 'Erst {label} und Position wählen';
    public readonly ChooseDefault = 'Bitte auswählen';
    public readonly ChooseFirst = 'Erst {label} wählen';
    public readonly Close = 'Schließen';
    public readonly DiffNoChanges = 'Es gibt keine Änderungen.';
    public readonly DiffStats = '{added} Zeichen hinzugefügt, davon {invisibleAdded} unsichtbar. {removed} Zeichen entfernt, davon {invisibleRemoved} unsichtbar.';
    public readonly Color = 'Farbe';
    public readonly Confidential = 'Vertrauliche Informationen!';
    public readonly ContactEmail = 'Eigene E-Mail-Adresse';
    public readonly Copied = 'Kopiert';
    public readonly Copy = 'Kopieren';
    public readonly CopyFailed = 'Das Kopieren hat nicht geklappt.';
    public readonly Copyright = '© DWC';
    public readonly CreatedAt = 'Erstellt am';
    public readonly DarkMode = 'Dunkler Modus';
    public readonly Delete = 'Löschen';
    public readonly Descending = 'Absteigend';
    public readonly Details = 'Details';
    public readonly Discard = 'Verwerfen';
    public readonly Done = 'Erledigt';
    public readonly Edit = 'Bearbeiten';
    public readonly Email = 'E-Mail';
    public readonly EmailEnterFirst = 'Erst eine gültige E-Mail-Adresse eingeben';
    public readonly EmailLastProtected = 'Letzte E-Mail-Adresse eines Benutzers kann nicht gelöscht werden';
    public readonly EmailNew = 'Neue E-Mail-Adresse';
    public readonly EmailNoPrimary = 'Keine primäre Adresse gewählt — beim Speichern wird es die zuletzt zugeordnete.';
    public readonly EmailPrimary = 'Primäre Adresse';
    public readonly EmailRemove = 'Adresse entfernen';
    public readonly EmailSetPrimary = 'Als primäre Adresse festlegen';
    public readonly EmailUserHint = 'Diese Person ist ein Benutzer und benötigt mindestens eine E-Mail-Adresse.';
    public readonly Emails = 'E-Mail-Adressen';
    public readonly EmailsEdit = 'E-Mail-Adressen bearbeiten';
    public readonly Empty = '–';
    public readonly Entries = 'Einträge';
    public readonly EntriesCount = '{count} Einträge';
    public readonly EntriesPerPage = 'Einträge pro Seite';
    public readonly Entry = 'Eintrag';
    public readonly FamilyName = 'Nachname';
    public readonly GivenName = 'Vorname';
    public readonly Greeting = 'Servus {name}!';
    public readonly HoldHint = 'Bitte gedrückt halten für {seconds} Sekunden.';
    public readonly HoldHintOne = 'Bitte gedrückt halten für 1 Sekunde.';
    public readonly Info = 'Info';
    public readonly InfoSortHint = 'Klicken: Sortierung nach ID (ASC/DESC) → Erstellt am (ASC/DESC) → Geändert am (ASC/DESC) umschalten';
    public readonly LastLogin = 'Letzte Anmeldung';
    public readonly LightMode = 'Heller Modus';
    public readonly Loading = 'Wird geladen…';
    public readonly Login = 'Anmelden';
    public readonly LogoAlt = 'DWC-Tools Logo';
    public readonly MainNavigation = 'Hauptnavigation';
    public readonly MenuOpen = 'Menü öffnen';
    public readonly Name = 'Name';
    public readonly Nickname = 'Spitzname';
    public readonly No = 'Nein';
    public readonly NoAssignments = 'Keine Zuordnungen.';
    public readonly NoTags = 'Keine Tags vorhanden.';
    public readonly TagName = '#{tag}';
    public readonly NoColor = 'Keine Farbe';
    public readonly NoEmails = 'Keine E-Mail-Adressen.';
    public readonly NoEntries = 'Keine Einträge vorhanden.';
    public readonly NoFavorites = 'Keine Favoriten vorhanden…';
    public readonly NoMessages = 'Keine Benachrichtigungen vorhanden…';
    public readonly NoOrganizations = 'Keine Firmen zugeordnet.';
    public readonly NoPageRights = 'Für die Seite „{page}“ fehlt Dir die Berechtigung.';
    public readonly NothingFound = 'Nichts gefunden.';
    public readonly Of = 'von';
    public readonly Open = 'Öffnen';
    public readonly PageChoose = 'Seite auswählen';
    public readonly PageFirst = 'Erste Seite';
    public readonly PageJump = 'Zur Seite springen';
    public readonly PageJumpHint = 'Wähle eine Seite oder gib eine Seitennummer von 1 bis {pages} ein.';
    public readonly PageLast = 'Letzte Seite';
    public readonly PageNext = 'Nächste Seite';
    public readonly PageNumber = 'Seitennummer';
    public readonly PagePrevious = 'Vorherige Seite';
    public readonly PageSettings = 'Seiteneinstellungen';
    public readonly PageWithNumber = '{label} ({page})';
    public readonly PageWord = 'Seite';
    public readonly PasswordSendToUser = 'Passwort an Benutzer senden?';
    public readonly Person = 'Person';
    public readonly PersonEdit = 'Person bearbeiten';
    public readonly PersonId = 'Personen-ID';
    public readonly Position = 'Position';
    public readonly PositionChoose = 'Position auswählen';
    public readonly Processing = 'Verarbeitung';
    public readonly QuickAccess = 'Schnellzugriff';
    public readonly Reset = 'Zurücksetzen';
    public readonly RootOnly = 'Nur für Root sichtbar';
    public readonly Save = 'Speichern';
    public readonly Search = 'Suchen';
    public readonly SearchArea = 'Bereich';
    public readonly SearchBelowMinimum = 'Dev: unter der Mindestqualität';
    public readonly SearchEmpty = 'Für diese Suche gibt es keine Treffer.';
    public readonly SearchFoundIn = 'Gefunden in: {fields}';
    public readonly SearchHint = 'Gib einen Suchbegriff ein. Mit # suchst Du nach einem Tag.';
    public readonly SearchHit = 'Treffer';
    public readonly SearchHitsLabel = 'Beste Treffer';
    public readonly SearchIgnored = 'Nicht berücksichtigt';
    public readonly SearchInfos = 'Infos';
    public readonly SearchPlaceholder = 'Suchen…';
    public readonly SearchQuality = 'Qualität';
    public readonly SearchedFor = 'Gesucht wird nach';
    public readonly SettingsOpen = 'Einstellungen öffnen';
    public readonly Sort = 'Sortierung';
    public readonly SortAscending = 'aufsteigend';
    public readonly SortCreatedAsc = 'created_at ASC';
    public readonly SortCreatedDesc = 'created_at DESC';
    public readonly SortDefault = 'Standard';
    public readonly SortDescending = 'absteigend';
    public readonly SortDirection = 'Sortierrichtung';
    public readonly SortIdAsc = 'ID ASC';
    public readonly SortIdDesc = 'ID DESC';
    public readonly SortLabel = '{name} · {direction}';
    public readonly SortUpdatedAsc = 'updated_at ASC';
    public readonly SortUpdatedDesc = 'updated_at DESC';
    public readonly SortedBy = 'Sortiert nach';
    public readonly Teams = 'Teams';
    public readonly TextBold = 'Fett';
    public readonly TextItalic = 'Kursiv';
    public readonly Titles = 'Titel';
    public readonly Unlink = 'Verknüpfung lösen';
    public readonly UnlinkAssignment = 'Zuordnung lösen';
    public readonly UpdatedAt = 'Geändert am';
    public readonly User = 'Benutzer';
    public readonly UserId = 'Benutzer-ID';
    public readonly Yes = 'Ja';

    /** A tag as everybody reads it. */
    public getTagName(tag: string): string {
        return this.format(this.TagName, { tag });
    }
}

export const CommonTexts = new CommonTextsClass();
